export const GET_CURRENT_TYPE = 'GET_CURRENT_TYPE';


